import { ColoredButton } from '@components/colored-elements';
import { rbac } from '@lib/common';
import { Grid } from '@material-ui/core';
import {
  lightGreen, red
} from '@material-ui/core/colors';
import CancelIcon from '@material-ui/icons/CancelRounded';
import SaveIcon from '@material-ui/icons/SaveRounded';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { useHistory } from 'react-router-dom';

export function FormActions({
  submitForm = null,
}) {
  const history = useHistory();
  const form = useFormContext();

  const onSave = useCallback(() => {
    submitForm && submitForm(form.getValues());
  }, [submitForm]);

  return (
    <Grid container spacing={2}>
      <Grid item xs>
        &nbsp;
      </Grid>
      <Grid item>
        <ColoredButton
          colored={red[500]}
          coloredHover={red[900]}
          startIcon={<CancelIcon />}
          variant="contained"
          size="small"
          // className={classes.paddingAll}
          onClick={() => history.push('/company-person/search')}>
          Cancel
        </ColoredButton>
      </Grid>
      <Grid item>
        <ColoredButton
          colored={lightGreen[700]}
          coloredHover={lightGreen[900]}
          startIcon={<SaveIcon />}
          variant="contained"
          size="small"
          disabled={rbac('C2P_New', '', 'Button')}
          onClick={onSave}>
          Save
        </ColoredButton>
      </Grid>
    </Grid>
  );
}
